import { useTranslation } from 'react-i18next';
import s from './Sidebar.module.css';

/** The logo: a 26px orange rounded square with a dark circle notch, the name and «внутренняя платформа». */
export function Logo() {
  const { t } = useTranslation('shell');
  return (
    <div className={s.logo}>
      <div className={s.mark}>
        <div className={s.markNotch} />
      </div>
      <div className={s.brand}>
        <span className={s.brandName}>{t('brand')}</span>
        <span className={s.brandSub}>{t('brand_sub')}</span>
      </div>
    </div>
  );
}
